import React from 'react';

import { Button } from '@lightspeed/flame/Button';
import { Flex } from '@lightspeed/flame/Core';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '@lightspeed/flame/Modal';
import { Spinner } from '@lightspeed/flame/Spinner';
import { Text } from '@lightspeed/flame/Text';

import { StatusDataContext } from 'root/apps/InventoryCount/contexts/StatusData';

interface Modal {
  isModalOpen: boolean;
  resetState: (state: boolean) => void;
}

const ResetImportModal: React.FC<Modal> = ({ isModalOpen, resetState }) => {
  const { isLoading, deleteImportProcess } = React.useContext(StatusDataContext);

  return (
    <Modal isOpen={isModalOpen} onRequestClose={() => resetState(false)} css={{ width: '600px' }}>
      <ModalHeader onCloseClicked={() => resetState(false)}>
        <Text size="large" fontWeight={600} data-test="reset-import-title">
          You’re about to lose your import progress
        </Text>
      </ModalHeader>
      <ModalBody>
        <Text>Are you sure you want to restart your import?</Text>
      </ModalBody>
      <ModalFooter>
        <Flex justifyContent="right">
          <Button onClick={() => resetState(false)}>Cancel</Button>
          <Button
            width={135}
            variant="danger"
            fill
            ml={2}
            onClick={() => deleteImportProcess()}
            data-test="modal-reset-import-btn"
          >
            {isLoading ? <Spinner /> : 'Restart import'}
          </Button>
        </Flex>
      </ModalFooter>
    </Modal>
  );
};

export default ResetImportModal;
